module.exports = __webpack_public_path__ + "img/mastercard-primary-large.478335ad.png";